var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * Get the locale that is a case insensitive match in the available locales
 * @param languageCode the language code for the locale to look-up
 * @param countryCode the country code for the locale to look-up
 * @param availableLocales an object where the keys are locale codes and the values are locales
 * @returns {*}
 */
function getAvailableLocale(languageCode, countryCode, availableLocales) {
    var targetLocaleHyphen = (languageCode + "-" + countryCode).toLowerCase();
    var targetLocaleUnderscore = (languageCode + "_" + countryCode).toLowerCase();
    var localeCode = Object.keys(availableLocales).find(function (locale) {
        var lowerCaseLocale = locale.toLowerCase();
        return (lowerCaseLocale === targetLocaleHyphen ||
            lowerCaseLocale === targetLocaleUnderscore);
    });
    return availableLocales[localeCode];
}
/**
 * Default mappings for 2-letter locale codes to 4-letter locale codes
 */
var baseDefaultLocales = {
    bg: 'bg-BG',
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    el: 'el-GR',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hr: 'hr-HR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    nb: 'no-NO',
    nl: 'nl-NL',
    no: 'no-NO',
    pl: 'pl-PL',
    pt: 'pt-PT',
    ro: 'ro-RO',
    ru: 'ru-RU',
    sk: 'sk-SK',
    sl: 'sl-SL',
    sr: 'sr-RS',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
/**
 * Get the locale that is the closest match to the one provided. Will first check for an exact match, then fall-back to
 * default locale for that language.
 * @param localeCode the code for the locale to look-up
 * @param availableLocales an object where the keys are locale codes and the values are locales
 * @param defaultLocales override for the default locale codes for languages
 * @param fallbackLocale locale to default to if no match could be found
 * @returns {*}
 */
export default function getMatchingLocale(localeCode, availableLocales, defaultLocales, fallbackLocale) {
    if (defaultLocales === void 0) { defaultLocales = {}; }
    var _a = __read(localeCode.replace('_', '-').split('-'), 2), languageCode = _a[0], countryCode = _a[1];
    var availableLocale;
    // checks full 4-letter codes
    if (countryCode) {
        availableLocale = getAvailableLocale(languageCode, countryCode, availableLocales);
        if (availableLocale) {
            return availableLocale;
        }
    }
    // checks defaultLocales against a 2-letter languageCode
    var mergedDefaultLocales = __assign(__assign({}, baseDefaultLocales), defaultLocales);
    var defaultLocale = mergedDefaultLocales[languageCode];
    if (defaultLocale) {
        var _b = __read(defaultLocale.split('-'), 2), defaultLanguageCode = _b[0], defaultCountryCode = _b[1];
        availableLocale = getAvailableLocale(defaultLanguageCode, defaultCountryCode, availableLocales);
        if (availableLocale) {
            return availableLocale;
        }
    }
    // uses provided fallback locale if available
    if (fallbackLocale) {
        var _c = __read(fallbackLocale.split('-'), 2), fallbackLanguageCode = _c[0], fallbackCountryCode = _c[1];
        availableLocale = getAvailableLocale(fallbackLanguageCode, fallbackCountryCode, availableLocales);
        if (availableLocale) {
            return availableLocale;
        }
    }
    throw new Error("no available locale matching " + localeCode);
}
